import React, { useState, useEffect, useRef, useCallback } from "react";
import loadingGif from "../assest/Loading.gif";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from 'rehype-raw';
import nerdyicon from "../assest/purple-cuts-small.png";
import Mic from "../assest/mic-2.png";
import Stop from "../assest/stop-mic.png";
import { useTranslation } from "react-i18next";
import i18n from "../i18n.js";
import { useNavigate } from "react-router-dom";
import { logout } from '../features/auth/authSlice.js'
import { useDispatch } from "react-redux";

const ChatContainer = ({ dir }) => {

  const chatContainerRef = useRef(null);
  const [question, setQuestion] = useState("");
  const [, setResponse] = useState("");
  const [loading, setLoading] = useState(false);
  const [conversation, setConversation] = useState([]);
  const [, setDocumentDetails] = useState([]);
  const [responseStream, setResponseStream] = useState("");
  const [Error,] = useState(null);
  const [sessionNumber, setSessionNumber] = useState(null);
  const [latestSession, setLatestSession] = useState();
  const [currentSessionId, setCurrentSessionId] = useState(null);
  const [userSession, setUserSession] = useState([]);
  const { t } = useTranslation();
  const [isRecording, setIsRecording] = useState(false);
  const recognitionRef = useRef(null);
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const storedData = localStorage.getItem("profileData");
  let parsedDataOutScope;
  if (storedData) {
    const parsedData = JSON.parse(storedData);
    parsedDataOutScope = parsedData;
  }

  const isDev = process.env.NODE_ENV === 'development';

  const handleSignout = useCallback(() => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("profileData");
    sessionStorage.removeItem("conversation");
    sessionStorage.removeItem("currentSessionId");
    sessionStorage.removeItem("sessionNumber");
    sessionStorage.removeItem("sessions");
    dispatch(logout())
    navigate("/login");
  }, [navigate, dispatch]);

  const hitRatingApi = async (ratingType, lastQuestion, thisResponse, referenceDoc) => {

    const response = await fetch(
      `${process.env.REACT_APP_PORTAL_APP_BASE_URL}/admin/support/rating`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: `${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          RatingType: ratingType,
          question: lastQuestion,
          answer: thisResponse,
          documentFileNames: referenceDoc,
        }),
      }
    );
    console.log(response);
  }

  const fetchSessions = useCallback(async () => {
    try {
      const baseUrl = process.env.REACT_APP_BASEURL;
      const token = localStorage.getItem("token");

      if (!token) {
        throw new Error(t("Authentication token not found. Please log in again."));
      }

      const response = await fetch(`${baseUrl}/get_user_sessions`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`${t("error_fetching_sessions")}: ${response.status} ${response.statusText} - ${errorText}`);
      }

      const data = await response.json();
      const apiResponse = {
        sessionIds: data?.sessions?.map(session => session.sessionId)
      };

      console.log(apiResponse, "Transformed API Response");
      setUserSession(apiResponse);
      return apiResponse;
    } catch (err) {
      if (err?.response?.status === 401) {
        handleSignout();
      }
      console.error("Failed to fetch sessions:", err);
      return [];
    }
  }, [Error, t, handleSignout]);

  const getNextAvailableSessionId = (existingSessionIds) => {
    let i = 1;
    let newId;
    do {
      newId = `Session-${i}`;
      i++;
    } while (existingSessionIds.includes(newId));
    return newId;
  };
  useEffect(() => {
    // Only update the sessionStorage if we have a valid current session ID
    if (currentSessionId && conversation.length > 0) {
      const savedSessions = JSON.parse(sessionStorage.getItem("sessions")) || [];

      // Find the index of the current session in the array
      const sessionIndex = savedSessions.findIndex(session => session.id === currentSessionId);

      if (sessionIndex >= 0) {
        // Update the existing session
        savedSessions[sessionIndex] = {
          ...savedSessions[sessionIndex],
          conversation
        };
      } else {
        // Add a new session
        savedSessions.push({
          id: currentSessionId,
          name: latestSession || `Session ${sessionNumber}`,
          date: new Date().toLocaleString(),
          conversation
        });
      }
      sessionStorage.setItem("sessions", JSON.stringify(savedSessions));
      sessionStorage.setItem("conversation", JSON.stringify(conversation));
    }
  }, [conversation, currentSessionId, latestSession, sessionNumber]);

  const handleStream = async () => {

    if (!question.trim()) return;

    // setDocumentInfo([]);
    // setCurrentQuestion(question);
    setResponse("");
    setResponseStream("");
    // setHelperButton(false);
    setLoading(true);

    const newUserMessage = {
      id: `user-${Date.now()}`,
      sender: "user",
      message: question,
    };

    setConversation((prev) => [...prev, newUserMessage]);

    try {

      console.log("check hit open:")
      const responseStream = await fetch(
        `${process.env.REACT_APP_BASEURL}/stream_response`,

        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },

          body: JSON.stringify({
            query: question,
            chat_history: conversation.map((msg) => msg.message),
            language: "en",
            session_id: currentSessionId,
          }),
        }
      );

      console.log("check hit close: ", responseStream)

      if (!responseStream.ok) {
        throw new Error(
          `Server responded with status ${responseStream.status}`
        );
      }

      const reader = responseStream.body.getReader();
      const decoder = new TextDecoder();
      let done = false;
      let accumulatedResponse = "";
      let displayedResponse = "";

      // Create a buffer to hold partial content that might include special sections
      let buffer = "";
      const referencePattern = /\*\*References:\*\*([\s\S]*?)(?=\n\*\*|$)/;
      const followUpPattern = /\*\*followUp:\*\*([\s\S]*?)(?:$)/;
      const tableHeaderPattern = /\|\s*\*\*Document Name\*\*\s*\|\s*\*\*Section Name\*\*\s*\|\s*\*\*Section Number\*\*\s*\|/;
      const tableRowPattern = /\|[^|]*\|[^|]*\|[^|]*\|/g;

      // Multiple question patterns to catch different formats
      const questionPatterns = [
        /\*\* Question:[\s\S]*?(?=\*\*|\n\n|$)/g,     // Format: ** Question:
        /\*\*Question:[\s\S]*?(?=\*\*|\n\n|$)/g,      // Format: **Question:
        /\*\*\s*Question:[\s\S]*?(?=\*\*|\n\n|$)/g,   // Format with varying spaces
        /\*\* Question: What would[\s\S]*?(?=\*\*|\n\n|$)/g, // Specific pattern with content
        /\*\* Question[\s\S]*?(?:Something else entirely|$)/g, // Most generic pattern
        /\*\*[\s\S]*?Question:[\s\S]*?(?:Something else|$)/g,  // Super generic pattern
        /\*\*Referenced Files Metadata:[\s\S]*?(?=\*\*Referenced Files:|$)/g,
        /\*\*Referenced Files:\*\*[\s\S]*/g
      ];

      while (!done) {
        const { value, done: streamDone } = await reader.read();
        done = streamDone;

        if (value) {
          const chunk = decoder.decode(value, { stream: true });

          // Add to accumulated response for later processing
          accumulatedResponse += chunk;

          // Add to buffer for filtering
          buffer += chunk;

          // Check if buffer contains any special sections to remove
          let cleanBuffer = buffer;

          // Remove any references section
          const refMatch = cleanBuffer.match(referencePattern);
          if (refMatch) {
            cleanBuffer = cleanBuffer.replace(referencePattern, "");
          }

          // Remove any followUp section
          const followUpMatch = cleanBuffer.match(followUpPattern);
          if (followUpMatch) {
            cleanBuffer = cleanBuffer.replace(followUpPattern, "");
          }

          // Check for document tables
          if (cleanBuffer.includes("Document Name") || cleanBuffer.match(tableHeaderPattern)) {
            // Remove entire table header row
            cleanBuffer = cleanBuffer.replace(tableHeaderPattern, "");

            // Remove any table rows
            cleanBuffer = cleanBuffer.replace(tableRowPattern, "");
          }

          // Remove question sections with options - try all patterns
          for (const pattern of questionPatterns) {
            cleanBuffer = cleanBuffer.replace(pattern, "");
          }

          // Look for question section keywords without regex for additional filtering
          if (cleanBuffer.includes("** Question:") || cleanBuffer.includes("**Question:")) {
            // Additional keyword-based removal
            const lines = cleanBuffer.split('\n');
            const filteredLines = lines.filter(line =>
              !line.includes("Question:") &&
              !line.includes("Requesting transportation") &&
              !line.includes("Scheduling a shuttle") &&
              !line.includes("Understanding itinerary") &&
              !line.includes("Something else") &&
              !line.includes("**Referenced Files Metadata:**") &&
              !line.includes("**Referenced Files:**")
            );
            cleanBuffer = filteredLines.join('\n');
          }

          // Update displayed response - only show parts we're sure are clean
          // Keep buffer size reasonable by only keeping potential partial sections
          if (cleanBuffer.length > 100) {
            // Add most of the clean buffer to displayed response
            const addToDisplay = cleanBuffer.slice(0, cleanBuffer.length - 50);
            displayedResponse += addToDisplay;
            console.log(displayedResponse, "displayedResponse");
            setResponseStream(displayedResponse);
            // Keep only the last part in the buffer for continued checking
            buffer = cleanBuffer.slice(cleanBuffer.length - 50);
          }

          setLoading(false);
          setQuestion("");
        }
      }

      // Process the full complete response for extraction
      const formattedResponse = accumulatedResponse
        .replace(/answer:\s*/gi, "")
        .trim();

      // Extract references, suggested questions, and document details from the response
      let extractedReferences = "";
      let extractedSuggestedQuestions = [];
      let extractedDocumentDetails = [];

      // Look for References section in the response
      if (formattedResponse.includes("**References:**") || formattedResponse.includes("References:")) {
        const referencesMatch = formattedResponse.match(referencePattern);
        if (referencesMatch && referencesMatch[1]) {
          extractedReferences = "**References:**" + referencesMatch[1].trim();
        }
      }

      // Look for followUp section for suggested questions
      if (formattedResponse.includes("**followUp:**") || formattedResponse.includes("followUp:")) {
        const followUpMatch = formattedResponse.match(followUpPattern);
        if (followUpMatch && followUpMatch[1]) {
          let followUpContent = followUpMatch[1].trim();
          // Clean out any referenced file sections
          followUpContent = followUpContent
            .replace(/\*\*Referenced Files Metadata:\*\*[\s\S]*?(?=\*\*Referenced Files:|$)/g, "")
            .replace(/\*\*Referenced Files:\*\*[\s\S]*/g, "")
            .trim();

          // Extract the main question
          const questionMatch = followUpContent.match(
            /Question:(.*?)(?:\d\.|\n\n|$)/s
          );
          const mainQuestion = questionMatch ? questionMatch[1].trim() : "";

          // Extract the numbered options
          const optionsMatches = followUpContent.matchAll(
            /(\d+)\.\s+(.*?)(?=\d+\.|$)/gs
          );
          const options = Array.from(optionsMatches, (match) =>
            match[2].trim()
          );

          if (mainQuestion && options.length > 0) {
            extractedSuggestedQuestions = [
              {
                question: mainQuestion,
                options: options,
              },
            ];
          }
        }
      }

      const referencedFilesPattern = /\*\*Referenced Files:\*\*([\s\S]*?)(?:\n\n|\*\*|$)/;
      const referencedFilesMatch = formattedResponse.match(referencedFilesPattern);

      if (referencedFilesMatch && referencedFilesMatch[1]) {
        const referencedFileEntries = referencedFilesMatch[1]
          .split(",")
          .map((entry) => entry.trim())
          .filter(Boolean);

        const extractedDocumentDetails = [];

        referencedFileEntries
          .flatMap(entry => entry.split(/,(?=\s*[^:]+?\.(pdf|docx?|docs)\s*:)/i)) // Split correctly by comma + lookahead
          .forEach((entry) => {
            const match = entry.match(/^([\w\s\-()[\]@#&',.]+?\.(pdf|docx?|docs))\s*:\s*([\d.]+)$/i);
            if (match) {
              const fileName = match[1].trim();
              const fileScore = parseFloat(match[3]);
              console.log(fileName, "→ check Documents inside the regex");
              extractedDocumentDetails.push({ fileName, score: fileScore });

              const encodedName = encodeURIComponent(fileName);
              console.log(encodedName, "→ Document name in PDF");

              fetch(`${process.env.REACT_APP_PORTAL_APP_BASE_URL}/documents/getDocumentName?search=${encodedName}`, {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  token: `${localStorage.getItem("token")}`,
                },
              })
                .then((res) => {
                  if (!res.ok) {
                    throw new Error(`API failed for document: ${fileName}`);
                  }
                  return res.json();
                })
                .then((data) => {
                  console.log("API result for", fileName, "→", data);
                  //   setDocumentInfo((prev) => [...prev, { documentName: fileName, score: fileScore, data }]);
                  //   setDocumentCount(extractedDocumentDetails.length);
                  if (extractedDocumentDetails.length > 0) {
                    // setHelperButton(true);
                  }
                })
                .catch((err) => {
                  console.error("Error fetching document info:", err);
                });
            }
          });
      }

      // Clean the full response one more time to ensure all special sections are removed
      let cleanedFullResponse = formattedResponse;
      cleanedFullResponse = cleanedFullResponse.replace(referencePattern, "");
      cleanedFullResponse = cleanedFullResponse.replace(followUpPattern, "");
      cleanedFullResponse = cleanedFullResponse.replace(/\*\*Referenced Files Metadata:\*\*[\s\S]*?(?=\*\*|$)/g, "");

      // Remove all possible question patterns
      for (const pattern of questionPatterns) {
        cleanedFullResponse = cleanedFullResponse.replace(pattern, "");
      }

      // Second pass using line-by-line filtering to catch any remaining question sections
      const lines = cleanedFullResponse.split('\n');
      const filteredLines = lines.filter(line =>
        !line.includes("** Question:") &&
        !line.includes("**Question:") &&
        !line.includes("Requesting transportation") &&
        !line.includes("Scheduling a shuttle") &&
        !line.includes("Understanding itinerary") &&
        !line.includes("Something else") &&
        !line.includes("**Referenced Files Metadata:**") &&
        !line.includes("**Referenced Files:**")
      );

      cleanedFullResponse = filteredLines.join('\n');

      // Remove document tables
      if (cleanedFullResponse.includes("Document Name")) {
        const tableLines = cleanedFullResponse.split("\n");
        const cleanedLines = tableLines.filter(line =>
          !line.includes("Document Name") &&
          !line.match(/\|[^|]*\|[^|]*\|[^|]*\|/)
        );
        cleanedFullResponse = cleanedLines.join("\n");
      }

      // Final cleanup and trim
      cleanedFullResponse = cleanedFullResponse.trim();
      // Allow time for new message to render
      setTimeout(() => {
        if (chatContainerRef.current) {
          chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
      }, 100);
      // Set the extracted data
      //   setReferences(extractedReferences || "No references found.");
      //   setSuggestedQuestions(extractedSuggestedQuestions);
      setDocumentDetails(extractedDocumentDetails.join("\n"));
      //   setDocumentCount(extractedDocumentDetails.length);

      console.log(extractedReferences, "extractedReferences check on handlestream");
      // Show helper buttons if we have any of these features
      if (
        extractedReferences ||
        extractedSuggestedQuestions.length > 0 ||
        extractedDocumentDetails.length > 0
      ) {
        // setHelperButton(true);
      }

      const newAiMessage = {
        id: `ai-${Date.now()}`,
        sender: "ai",
        message: cleanedFullResponse,
        ratingGiven: null // Add a field to track if rating was given
      };

      setConversation((prev) => [...prev, newAiMessage]);
      hitRatingApi("Nothing", question, cleanedFullResponse, extractedDocumentDetails);
      // Clear the stream display
      setTimeout(() => {
        setResponseStream("");
      }, 50);
    } catch (error) {
      console.error("Error fetching response:", error);
    } finally {
      setLoading(false);
      //   setHelperLoader(false);
    }
  };

  const handleSend = async () => {
    if (!question.trim()) return;
    setLoading(true);
    // Allow time for new message to render
    setTimeout(() => {
      if (chatContainerRef.current) {
        chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
      }
    }, 100);
    try {
      await handleStream();
    } catch (error) {
      console.error("Error executing API:", error);
    } finally {
      setLoading(false);
    }
  };


  // Function to handle rating submissions
  const handleRating = async (messageId, ratingType) => {
    try {
      // Find the last question and this response
      const messageIndex = conversation.findIndex(
        (msg) => msg.id === messageId
      );
      if (messageIndex <= 0) return; // Safety check

      // Get the last question (should be right before this response)
      const lastQuestion = conversation[messageIndex - 1].message;
      const thisResponse = conversation[messageIndex].message;

      const response = await fetch(
        `${process.env.REACT_APP_PORTAL_APP_BASE_URL}/admin/support/rating`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token: `${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({
            RatingType: ratingType,
            question: lastQuestion,
            answer: thisResponse,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`Server responded with status ${response.status}`);
      }

      // Update conversation to mark the message as rated
      setConversation((prev) =>
        prev.map((msg) =>
          msg.id === messageId ? { ...msg, ratingGiven: ratingType } : msg
        )
      );
    } catch (error) {
      console.error("Error submitting rating:", error);
    }
  };

  useEffect(() => {
    fetchSessions();
  }, [fetchSessions])


  useEffect(() => {
    const savedConversation = sessionStorage.getItem("conversation");
    const savedSessionId = sessionStorage.getItem("sessionNumber");

    if (savedConversation && savedSessionId) {
      console.log(savedSessionId, "savedSessionId");

      const parsedConversation = JSON.parse(savedConversation);
      setConversation(parsedConversation);
      setCurrentSessionId(savedSessionId);
      setLatestSession(savedSessionId);

      setTimeout(() => {
        if (chatContainerRef.current) {
          chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
      }, 100);
    } else {
      const existingSessionIds = userSession.sessionIds || [];
      const initialSessionId = getNextAvailableSessionId(existingSessionIds);

      console.log(initialSessionId, "Initial session ID determined");
      setCurrentSessionId(initialSessionId);
      setLatestSession(initialSessionId);

      // sessionStorage.setItem("sessionNumber", initialSessionId);
      setSessionNumber(initialSessionId);
    }

  }, [isDev, userSession.sessionIds]);

  useEffect(() => {
    if ("webkitSpeechRecognition" in window || "SpeechRecognition" in window) {
      const SpeechRecognition =
        window.SpeechRecognition || window.webkitSpeechRecognition;
      const recognition = new SpeechRecognition();
      recognition.lang = i18n.language === "ar" ? "ar-SA" : "en-US";
      recognition.interimResults = true; // show real-time transcription
      recognition.continuous = false;

      recognition.onresult = (event) => {
        const transcript = Array.from(event.results)
          .map((result) => result[0].transcript)
          .join("");
        setQuestion(transcript);
      };

      recognition.onend = () => {
        setIsRecording(false);
      };

      recognitionRef.current = recognition;
    } else {
      alert("Your browser does not support Speech Recognition.");
    }
  }, [setQuestion]);

  const toggleRecording = () => {
    if (!recognitionRef.current) return;

    if (isRecording) {
      recognitionRef.current.stop();
      setIsRecording(false);
    } else {
      recognitionRef.current.start();
      setIsRecording(true);
    }
  };

  const isLastAIResponse = (msg) => {
    const aiMessages = conversation.filter((item) => item.sender === "ai");
    return (
      aiMessages.length > 0 && msg.id === aiMessages[aiMessages.length - 1].id
    );
  };

  const kioskWidth = window.innerWidth;
  const kioskHeight = window.innerHeight;
  console.log(kioskWidth, "-", kioskHeight)
  const isUrdu = (text) => /[\u0600-\u06FF]/.test(text);
  function isArabic(text) {
    // Arabic block: \u0600-\u06FF, Arabic Supplement: \u0750-\u077F, Arabic Extended-A: \u08A0-\u08FF
    return /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/.test(text);
  }

  return (
    <div dir={dir} className="min-h-full w-full flex h-[87vh]">
      <style>
        {`
          .custom-scrollbar::-webkit-scrollbar {
            width: 5px;
          }
          
          .custom-scrollbar::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 10px;
            display: none;
          }
          
          .custom-scrollbar::-webkit-scrollbar-thumb {
            background: #B03982;
            border-radius: 10px;
            display: none;
          }
          
          .custom-scrollbar.has-content::-webkit-scrollbar-track,
          .custom-scrollbar.has-content::-webkit-scrollbar-thumb {
            display: block;
          }
          
          .custom-scrollbar::-webkit-scrollbar-thumb:hover {
            background: #8c2d66;
          }

          .whitespace-pre-line {
            white-space: pre-line;
          }
          
          .active-rating {
            color: #B03982 !important;
          }
        `}
      </style>
      <div className="w-full relative">
        {/* Middle Div - Main Chat Area */}
        <div className="flex flex-col h-full">
          {/* Top Section - Chat Messages */}
          <div
            className="flex flex-col gap-4 custom-scrollbar overflow-y-auto flex-grow"
            ref={chatContainerRef}
          >
            {/* Display session history */}
            <div className="session-list mt-4">
              {latestSession && (
                <h2 className="text-sm font-bold">{latestSession}</h2>
              )}
            </div>
            {/* Greeting Card */}
            {conversation.length === 0 && (
              <div className="w-full p-4 bg-gray-100 rounded-lg shadow-md">
                <p className="text-sm font-semibold text-gray-800 mb-2">
                  {t("start_msg")}
                </p>
              </div>
            )}

            {/* Question and Response Area */}
            <div className="space-y-4">
              {conversation.map((msg) => (
                <div
                  key={msg.id}
                  className={`flex w-full mb-4 ${msg.sender === "user" ? "justify-end" : "justify-start"}`}
                >
                  {msg.sender === "user" ? (
                    <div
                      className={`flex items-end gap-2 w-full  text-right`}
                    >
                      {/* User initial */}
                      <div className="w-9 h-9 cursor-pointer rounded-full bg-gray-800 border-2 border-purple-500 flex items-center justify-center">
                        <span className="text-sm font-medium text-white">
                          {parsedDataOutScope?.name?.charAt(0) || "U"}
                        </span>
                      </div>

                      {/* Message text */}
                      <div
                        className={`flex-1 p-2 rounded-lg shadow-md bg-gray-100 text-gray-900 ${isUrdu(msg.message) || isArabic(msg.message) ? "text-right" : "text-left"
                          }`}
                      >
                        <h3 className="text-sm font-semibold break-words whitespace-normal">
                          {msg.message}
                        </h3>
                      </div>
                    </div>
                  ) : (
                    <div
                      className={`flex gap-2 items-start w-full text-right`}
                    >
                      {/* AI avatar */}
                      <div className="w-9 h-9 cursor-pointer rounded-full bg-white flex items-center justify-center">
                        <span className="text-1xl text-white leading-none">
                          <img src={nerdyicon} alt="AI" />
                        </span>
                      </div>

                      {/* AI response */}
                      <div
                        className={`flex-1 p-2 rounded-lg shadow-md bg-gray-100 text-gray-700 break-words whitespace-normal ${isUrdu(msg.message) || isArabic(msg.message) ? "text-right" : "text-left"
                          }`}
                      >
                        <ReactMarkdown
                          className="responseStream_Main_chatbot"
                          children={msg.message}
                          remarkPlugins={[remarkGfm]}
                          rehypePlugins={[rehypeRaw]}
                          unwrapDisallowed={false}
                        />

                        {/* Rating buttons */}
                        {isLastAIResponse(msg) && (
                          <div className={`flex ${dir === 'rtl' ? 'justify-end' : ''} mt-2 space-x-2`}>
                            <button
                              className={`text-gray-400 hover:text-black ml-2 ${msg.ratingGiven === "ThumbsUp" ? "active-rating" : ""}`}
                              onClick={() => handleRating(msg.id, "ThumbsUp")}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <path d="M7 10v12" />
                                <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a3.13 3.13 0 0 1 3 3.88Z" />
                              </svg>
                            </button>
                            <button
                              className={`text-gray-400 hover:text-black ml-2 ${msg.ratingGiven === "ThumbsDown" ? "active-rating" : ""}`}
                              onClick={() => handleRating(msg.id, "ThumbsDown")}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <path d="M17 14V2" />
                                <path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22h0a3.13 3.13 0 0 1-3-3.88Z" />
                              </svg>
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              ))}
              {/* Response Card */}
              <div>
                {loading && (
                  <div className="flex items-center justify-center w-full mb-2">
                    <img
                      src={loadingGif}
                      alt={t("loading")}
                      className="w-[10rem]"
                    />
                  </div>
                )}

                {responseStream && (
                  <div className="w-full p-4 bg-gray-100 rounded-lg shadow-md">
                    <ReactMarkdown
                      className="text-gray-700 responseStream_Main_chatbot"
                      children={responseStream}
                      remarkPlugins={[remarkGfm]}
                      rehypePlugins={[rehypeRaw]}
                      unwrapDisallowed={false}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* Bottom Section - Input Area */}
          <div className="relative w-full ">

            <div className="flex items-center border border-gray-300 rounded-lg focus-within:ring-2 focus-within:ring-[#B03982] overflow-hidden">
              <textarea
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
                onKeyDown={(e) => {
                  if (
                    e.key === "Enter" &&
                    !e.shiftKey &&
                    question.trim() &&
                    !loading
                  ) {
                    e.preventDefault();
                    handleSend();
                  }
                }}
                placeholder={t("ask_buddy")}
                disabled={loading}
                className="flex-grow text-sm h-9 px-2 py-2 focus:outline-none resize-none rounded-none disabled:bg-gray-100 disabled:cursor-not-allowed"
              />
              <button
                onClick={toggleRecording}
                className={`${dir === 'rtl' ? 'ml-2' : 'mr-2'}`}
              >
                {isRecording ? <img alt="Stop icon" src={Stop} width={35} /> : <img alt="Mic" src={Mic} width={35} />}
              </button>
              <button
                onClick={handleSend}
                disabled={!question.trim() || loading}
                className={`px-2 py-1 mr-2  rounded-lg text-white font-semibold ${question.trim() && !loading
                  ? "bg-[#B03982] hover:bg-[#B03982]"
                  : "bg-gray-300 cursor-not-allowed"
                  }`}
              >
                <i className="fa-sharp text-sm fa-solid fa-paper-plane"></i>
              </button>
            </div>
          </div>
          <p className="text-gray-500 text-sm mt-2 text-center">NerdyBuddy can be inaccurate; please double check its responses.</p>
        </div>

      </div>
    </div>
  );

};

export default ChatContainer;
